import React from 'react';
import { ViewWidget } from '@Components/ViewWidget';
import { Contact } from '../types';
import ContactViewForm from './ContactViewForm';

interface ContactViewWidgetProps {
  isOpen: boolean;
  contact: Contact | null;
  onClose: () => void;
}

const ContactViewWidget: React.FC<ContactViewWidgetProps> = ({
  isOpen,
  contact,
  onClose,
}) => {
  if (!contact) {
    return null;
  }

  return (
    <ViewWidget
      isOpen={isOpen}
      onClose={onClose}
      title="Contact Details"
      width={600}
    >
      <ContactViewForm contact={contact} />
    </ViewWidget>
  );
};

export default ContactViewWidget;
